export default {
  levelRecord: '/clientEcosys/courierLevel/levelRecord'
}
